import script from "./footerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./footerComponent.vue?vue&type=script&setup=true&lang=js"

import "./footerComponent.vue?vue&type=style&index=0&id=29371693&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29371693"]])

export default __exports__